import { selectEventPageData } from 'app/pages/EventDetailsPage/slice/selectors';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import LogoWrapper from '../LogoWrapper';

const Navbar: React.FC<{}> = () => {
  const { pathname } = useLocation();
  const {
    event: { cover, gallery },
    loading,
  } = useSelector(selectEventPageData);

  if (window.location !== window.parent.location)
    return <div className="iframe-header" />;

  const currentPageIsEventDetails =
    pathname.startsWith('/event/') && pathname.split('/').length === 3;
  const eventHasImageHero = cover || gallery.length > 0;
  const logoShouldBeHidden =
    loading || (currentPageIsEventDetails && eventHasImageHero);

  return (
    <nav
      className={`navbar-container ${
        logoShouldBeHidden ? 'event-has-image-hero' : ''
      } flex py-[8px] px-[16px] md:px-[24px] md:min-h-[72px] z-10`}
    >
      <div className="container">
        {logoShouldBeHidden ? null : <LogoWrapper />}
      </div>
    </nav>
  );
};

export default Navbar;
